import React from 'react';
import { useSelector } from 'react-redux';
import { indicator_ids, surveys } from '../store/slices/modelSurfaceSlice';
import { saveAs } from 'file-saver';

export default function DescriptionContainer() {
  const all_indicator_ids = useSelector(indicator_ids);
  const all_surveys = useSelector(surveys);

  function handleDataAvailability() {
    let headers = ['Country', 'Surveys'];
    all_indicator_ids.forEach((indicator_id) => {
      if (indicator_id !== 'pa_ckag_e_age') {
        headers.push(indicator_id);
      }
    });

    let csv = headers.join(',') + '\n';

    all_surveys.forEach((survey) => {
      let row = [survey.country.CountryName, survey.survey_name];

      survey.indicators.map((indicator) => {
        row[headers.indexOf(indicator.id)] = 'Yes';
      });

      csv += row.join(',') + '\n';
    });

    const blob = new Blob([csv], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, 'modeled-surface-data-availability.csv');
  }

  return (
    <div className='flex space-between flex-row'>
      <p className='description' style={{ paddingTop: '1em' }}>
        Each modeled surfaces is produced using standardized geostatistical methods, publically available DHS data, and
        a standardized set of covariates across countries.Each map package contains a mean estimate surface, an
        uncertainty surface, and corresponding information on the model creation process and validation.Not all
        indicators are available for all countries, a table summarizing the data available at the time of visit is
        available for download by clicking the Data Availability button.For more information on the modeling methods,
        refer to{' '}
        <a href='https://dhsprogram.com/publications/publication-SAR11-Spatial-Analysis-Reports.cfm' target='_blank'>
          {' '}
          Spatial Analysis Report 11
        </a>
        . For more information on the use of these surfaces in decision making, refer to{' '}
        <a href='https://dhsprogram.com/publications/publication-SAR14-Spatial-Analysis-Reports.cfm' target='_blank'>
          {' '}
          Spatial Analysis Report 14
        </a>
        .
      </p>
      <div className='data-availabilty-container flex align-center right-column justify-end'>
        <button className='download download--white data-availability' onClick={handleDataAvailability}>
          DATA AVAILABILITY
        </button>
      </div>
    </div>
  );
}
